(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var DURATION = 420;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  var items = document.querySelectorAll('details.c-faq-item');
  if (!items.length) return;

  Array.prototype.forEach.call(items, function (d) {
    var summary = d.querySelector('summary');
    var content = d.querySelector('.c-faq-item__a');
    if (!summary || !content) return;

    if (!content.dataset.smoothReady) {
      content.style.overflow = 'hidden';
      // Initial height: 0 if closed, otherwise auto-equivalent
      if (!d.open) {
        content.style.height = '0px';
      }
      content.dataset.smoothReady = '1';
    }

    var animating = false;

    function ontEnd(e, cb) {
      // Only listen to the height transition; iOS Safari can double-fire
      function handler(ev) {
        if (ev.propertyName !== 'height') return;
        content.removeEventListener('transitionend', handler);
        cb();
      }
      content.addEventListener('transitionend', handler);
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (animating) return;
      animating = true;

      if (d.open) {
        // ===== Close =====
        // Step 1: lock current height
        var startH = content.scrollHeight;
        content.style.transition = 'none';
        content.style.height = startH + 'px';
        // force reflow to commit the lock
        void content.offsetHeight;
        // Step 2: enable transition and animate to 0
        content.style.transition = 'height ' + DURATION + 'ms ' + EASE;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            content.style.height = '0px';
          });
        });
        ontEnd(null, function () {
          // Keep inline height: 0px to prevent native <details> hide flash on iOS
          content.style.transition = '';
          d.open = false;
          // Note: do NOT clear content.style.height — keep it 0px
          animating = false;
        });
      } else {
        // ===== Open =====
        d.open = true;
        // Ensure starting height is 0 (might be empty string after first cycle)
        content.style.transition = 'none';
        content.style.height = '0px';
        void content.offsetHeight;
        // Measure target height
        content.style.height = 'auto';
        var targetH = content.scrollHeight;
        content.style.height = '0px';
        void content.offsetHeight;
        // Animate
        content.style.transition = 'height ' + DURATION + 'ms ' + EASE;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            content.style.height = targetH + 'px';
          });
        });
        ontEnd(null, function () {
          content.style.transition = '';
          // After opening fully, allow auto height (so dynamic content reflows correctly)
          content.style.height = 'auto';
          animating = false;
        });
      }
    });
  });
})();
